import React, { Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react';
import './newsTopicLayout.scss';
import { axiosAuth } from '../../../api/api';
import { ICategoryNews, INews } from '../../../tpyes/comment';
import { useNavigate } from 'react-router-dom';

interface INewsTopicLayout {
  children: ReactNode;
  border?: boolean;
  setCategory?: Dispatch<SetStateAction<string>>;
  classNameLayout?: string;
  classNameContainer?: string;
  page?: string;
}
const NewsTopicLayout = ({ children = true, classNameContainer, classNameLayout, page }: INewsTopicLayout) => {
  const classes = `newsTopicLayout ${classNameLayout}`;
  const classesContainer = `container ${classNameContainer}`;
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  },[]);

  const getCategories = async () => {
    const response = await axiosAuth?.get('/news/api/news-category/');
    const dataList = response.data;
    const newCategories = dataList.map((item: INews) => item?.latest_news?.category);
    newCategories.unshift({ id: 100, name: 'ALL', order: 0, main_image: '' });
    setCategories(newCategories);
  };
  return (
    <div className={`${classes}  ${page === 'home' ? 'home-topic-box' : ''}`}>
      {null}
      <div className={`${classesContainer.trim()}`}>
        {page === 'home' ? (
          <div className="home-topic flex jc-between">
            <div className="title">News Topics</div>
            <div className="release-category flex">
              {categories.map((category: ICategoryNews) => {
                return (
                  <span
                    className="box"
                    key={category.id}
                    onClick={() => {
                      if (category.id === 100) {
                        navigate(`/newsTopic/`);
                      } else {
                        navigate(`/newsTopic/${category.id}`);
                      }
                    }}
                  >
                    {category.name}
                  </span>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
      {children}
    </div>
  );
};

export default NewsTopicLayout;
